import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Check, X, Clock, ShieldAlert } from 'lucide-react';
export function PricingSection() {
  const scrollToContact = () => {
    document.querySelector('#contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const comparisons = [{
    before: 'Buscar fotos por horas',
    after: 'Encuentras todo en segundos'
  }, {
    before: 'Armar informes manuales en Word',
    after: 'Generas reportes automáticos'
  }, {
    before: 'Decisiones perdidas en el chat',
    after: 'Historial permanente de decisiones'
  }, {
    before: 'Audios imposibles de revisar',
    after: 'Resúmenes y transcripción con IA'
  }, {
    before: 'Fotos sueltas sin contexto',
    after: 'Fotos ordenadas por obra, fecha y persona'
  }, {
    before: 'Información perdida si borran el grupo',
    after: 'Respaldo permanente online'
  }, {
    before: 'Capacitar al equipo en otra app',
    after: 'El equipo sigue usando WhatsApp'
  }];
  return <section id="precio" className="scroll-mt-20 py-12 sm:py-16 bg-gray-50" data-id="element-194">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="text-center mb-10 sm:mb-14 max-w-3xl mx-auto" data-id="element-196">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 mb-3 sm:mb-4 tracking-tight" data-id="element-197">
            Precio fijo por obra. Sin cobrar por usuario.
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-gray-600" data-id="element-198">
            Tu equipo completo puede participar sin preocuparse por licencias,
            usuarios o cupos.
          </p>
        </div>

        {/* Tiers */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 mb-6 sm:mb-8 items-stretch" data-id="element-199">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm text-center flex flex-col" data-id="element-200">
            <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-201">Piloto</h3>
            <p className="text-sm text-gray-500 mb-4" data-id="element-202">
              Para probar con una obra real
            </p>
            <div className="text-3xl font-extrabold text-gray-900 mb-1" data-id="element-203">
              Gratis
            </div>
            <p className="text-xs text-gray-400" data-id="element-204">por 7 días</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.05
        }} className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm text-center flex flex-col" data-id="element-205">
            <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-206">Obra Chica</h3>
            <p className="text-sm text-gray-500 mb-4" data-id="element-207">Hasta 1.500 m²</p>
            <div className="text-3xl font-extrabold text-blue-600 mb-1" data-id="element-208">
              UF 15
            </div>
            <p className="text-xs text-gray-400" data-id="element-209">al mes</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-blue-600 rounded-2xl p-6 border border-blue-700 shadow-md text-center flex flex-col" data-id="element-210">
            <h3 className="text-lg font-bold text-white mb-1" data-id="element-211">Obra Mediana</h3>
            <p className="text-sm text-blue-100 mb-4" data-id="element-212">Hasta 5.000 m²</p>
            <div className="text-3xl font-extrabold text-white mb-1" data-id="element-213">UF 35</div>
            <p className="text-xs text-blue-200" data-id="element-214">al mes</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm text-center flex flex-col" data-id="element-215">
            <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-216">
              Obra Grande
            </h3>
            <p className="text-sm text-gray-500 mb-4" data-id="element-217">Más de 5.000 m²</p>
            <div className="text-3xl font-extrabold text-blue-600 mb-1" data-id="element-218">
              UF 80+
            </div>
            <p className="text-xs text-gray-400" data-id="element-219">al mes</p>
          </motion.div>
        </div>

        <p className="text-center text-xs sm:text-sm text-gray-600 font-medium mb-10 sm:mb-12 px-2" data-id="element-220">
          Planes pagados incluyen{' '}
          <span className="text-gray-900 font-semibold" data-id="element-221">
            usuarios, mensajes y fotos sin límite razonable de uso.
          </span>
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden max-w-4xl mx-auto" data-id="element-222">
          {/* Column Headers */}
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200 p-4" data-id="element-223">
            <div className="text-center" data-id="element-224">
              <div className="text-[11px] sm:text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-225">
                Antes
              </div>
            </div>
            <div className="text-center" data-id="element-226">
              <div className="text-[11px] sm:text-xs font-bold text-blue-600 uppercase tracking-wider" data-id="element-227">
                Con Obra Digital
              </div>
            </div>
          </div>

          {/* Comparison Rows */}
          <div className="px-4" data-id="element-228">
            {comparisons.map((row, index) => <div key={index} className={`grid grid-cols-2 items-center py-3.5 gap-3 ${index < comparisons.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-229">
                <div className="flex items-start gap-2" data-id="element-230">
                  <X className="w-4 h-4 text-gray-300 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-231" />
                  <span className="text-[13px] sm:text-sm text-gray-500" data-id="element-232">
                    {row.before}
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-233">
                  <Check className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-234" />
                  <span className="text-[13px] sm:text-sm text-gray-900 font-medium" data-id="element-235">
                    {row.after}
                  </span>
                </div>
              </div>)}
          </div>

          {/* CTA */}
          <div className="p-4 sm:p-6 bg-gray-50 border-t border-gray-200" data-id="element-236">
            <button onClick={scrollToContact} className="w-full py-3.5 px-6 rounded-xl text-sm sm:text-base font-bold text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 transition-colors shadow-sm" data-id="element-237">
              Probar con una obra real
            </button>
          </div>
        </motion.div>

        {/* Value arguments */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mt-8 sm:mt-10 space-y-3 max-w-2xl mx-auto" data-id="element-238">
          <div className="flex items-start sm:items-center py-3 sm:py-3.5 px-4 sm:px-5 rounded-xl bg-white border border-gray-200 shadow-sm" data-id="element-239">
            <Clock className="w-4 h-4 mr-2.5 mt-0.5 sm:mt-0 text-gray-400 flex-shrink-0" data-id="element-240" />
            <span className="text-gray-700 font-medium text-xs sm:text-sm leading-snug" data-id="element-241">
              3 horas semanales armando informes{' '}
              <span className="text-blue-600 font-bold" data-id="element-242">
                = más caro que Obra Digital
              </span>
            </span>
          </div>
          <div className="flex items-start sm:items-center py-3 sm:py-3.5 px-4 sm:px-5 rounded-xl bg-white border border-gray-200 shadow-sm" data-id="element-243">
            <ShieldAlert className="w-4 h-4 mr-2.5 mt-0.5 sm:mt-0 text-gray-400 flex-shrink-0" data-id="element-244" />
            <span className="text-gray-700 font-medium text-xs sm:text-sm leading-snug" data-id="element-245">
              Una decisión perdida puede costar{' '}
              <span className="text-blue-600 font-bold" data-id="element-246">
                más que un año de respaldo
              </span>
            </span>
          </div>
        </motion.div>

        {/* Closing statement */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mt-12 sm:mt-20 px-4" data-id="element-247">
          <p className="text-xl sm:text-2xl lg:text-4xl font-extrabold text-gray-900 leading-tight tracking-tight max-w-3xl mx-auto" data-id="element-248">
            Las obras no fallan por falta de información.
            <span className="block text-blue-600 mt-2 sm:mt-3" data-id="element-249">
              Fallan porque la información se pierde.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}